// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"8eb707b7","157":"4a5d043c","702":"a23f7f09"}[chunkId] + ".chunk.css";
};